// Status code for client sharing

export enum LibraryItemShareStatus {
  IN_PROGRESS = 1,
  SUCCESS = 2,
  FAILED = 3,
}
